import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Repeat, Smartphone } from 'lucide-react';
export function Slide05ROI() {
  const stats = [{
    value: '6x',
    label: 'More valuable than retail players',
    icon: <TrendingUp data-id="element-187" />
  }, {
    value: '21x',
    label: 'More repeat play',
    icon: <Repeat data-id="element-188" />
  }, {
    value: '61%',
    label: 'Check their phone before visiting',
    icon: <Smartphone data-id="element-189" />
  }];
  return <div className="w-full min-h-full flex flex-col items-center justify-center p-[clamp(2rem,6vw,6rem)] text-center relative" data-id="element-190">
      {/* Background glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-191">
        <div className="w-[800px] h-[800px] bg-accent/5 rounded-full blur-[100px]" data-id="element-192" />
      </div>

      <div className="max-w-5xl w-full relative z-10" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-194">
          <h2 className="text-[clamp(3rem,6vw,5rem)] font-black leading-tight mb-6" data-id="element-195">
            Drive{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-emerald-300 text-glow" data-id="element-196">
              Real ROI
            </span>
          </h2>
          <p className="text-[clamp(1.25rem,2vw,1.5rem)] text-muted max-w-3xl mx-auto text-balance" data-id="element-197">
            Stop letting potential players drive away. Convert the pump into
            your most effective acquisition channel.
          </p>
        </motion.div>

        <div className="flex md:grid md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-16 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-2 md:pb-0" data-id="element-198">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3 + i * 0.1
        }} className="min-w-[100%] md:min-w-0 snap-center p-6 md:p-8 rounded-3xl bg-surface border border-surface-hover flex flex-col items-center text-center" data-id="element-199">
              <div className="text-accent mb-3 md:mb-4 opacity-80" data-id="element-200">
                {cloneElement(stat.icon as React.ReactElement, {
              size: 32
            })}
              </div>
              <div className="text-4xl md:text-5xl font-black text-white mb-2 tracking-tighter" data-id="element-201">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-muted font-medium" data-id="element-202">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8
      }} data-id="element-203">
          <a href="https://chalkline.pipedrive.com/scheduler/Rp64JRh9/chalkline-introduction" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-5 rounded-full bg-accent text-accent-contrast font-bold text-xl hover:bg-accent-hover transition-colors shadow-[0_0_30px_rgba(59,246,93,0.3)] hover:shadow-[0_0_40px_rgba(59,246,93,0.5)]" data-id="element-204">
            Start Your Pilot Program
          </a>
        </motion.div>
      </div>
    </div>;
}